import React, { forwardRef } from 'react';
import { RadioButton } from '../../atoms/radio/RadioButton';
import { RadioGroup } from '../../atoms/radio/RadioGroup';
import { Heading } from '../../typography/heading/Heading';
import styles from './TextSwatches.module.scss';
import { theme } from './options';

const TextSwatches = forwardRef(
  (
    {
      variants,
      name,
      activeRadio,
      className,
      onChange,
      activeVariant,
      getValue,
    },
    ref,
  ) => {
    const additionalStylesForRadio =
      theme === 'Jag' ? { labelText: styles.labelText } : {};

    return (
      <div className={`${styles.radioWrapper} ${className}`}>
        <Heading textTransform="uppercase" className={styles.titleAmount} as="h2">
          Gift Card amount*
        </Heading>
        <RadioGroup
          layout="column"
          customClasses={{
            column: styles.radioGroupColumn,
            root: styles.rootRadio,
            rootGroup: styles.rootGroup,
            groupColumn: styles.groupColumn,
            radiogroupWrapper: styles.radiogroupWrapper,
          }}
          onChange={onChange}
        >
          {variants?.map((el) => {
            let price = getValue(el.price);
            return (
              <RadioButton
                customClasses={{
                  root:
                    price === activeRadio
                      ? styles.rootActive
                      : styles.rootNotActive,
                  ...additionalStylesForRadio,
                }}
                key={el.id}
                value={price}
                name={name}
                ref={ref}
                onlyText={true}
                label={<span>{price}</span>}
                defaultChecked={price === activeRadio}
              />
            );
          })}
        </RadioGroup>
      </div>
    );
  },
);

export default TextSwatches;
